import * as React from 'react'

import { observer } from 'mobx-react'

interface Props {
  width?: number
  height?: number
  useCurrentColor?: boolean
}

function Logo(props: Props) {
  const { height, width } = props

  return (
    <svg
      width={width || 52}
      height={height || 18}
      viewBox="0 0 52 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Vector"
        d="M26.8932 6.41136C26.8635 8.78421 28.9777 10.1084 30.5704 10.8957C32.2068 11.7035 32.7565 12.2215 32.7502 12.9438C32.7377 14.0495 31.4448 14.5373 30.2347 14.5564C28.1236 14.5896 26.8963 13.9782 25.9204 13.5157L25.1599 17.1256C26.139 17.5834 27.9518 17.9826 29.8318 18C34.2445 18 37.1317 15.7903 37.1473 12.3641C37.1645 8.01596 31.2184 7.77519 31.259 5.83161C31.2731 5.24235 31.8274 4.6135 33.0422 4.45352C33.6434 4.37273 35.3032 4.31095 37.1848 5.19008L37.9234 1.69733C36.9115 1.3235 35.6108 0.965517 33.9916 0.965517C29.8381 0.965517 26.9166 3.20531 26.8932 6.41136ZM45.0202 1.26648C44.2145 1.26648 43.5353 1.74327 43.2324 2.47508L36.9287 17.7434H41.3383L42.2158 15.2834H47.6045L48.1135 17.7434H52L48.6085 1.26648H45.0202ZM45.637 5.71756L46.9096 11.9047H43.4244L45.637 5.71756ZM21.5467 1.26648L18.0709 17.7434H22.2728L25.747 1.26648H21.5467ZM15.3305 1.26648L10.9568 12.4813L9.18768 2.94553C8.98 1.88108 8.16023 1.26648 7.2499 1.26648H0.0999339L0 1.74485C1.46778 2.06799 3.13543 2.58913 4.1457 3.1467C4.76404 3.48727 4.94048 3.78506 5.14347 4.59449L8.49438 17.7434H12.9352L19.7432 1.26648H15.3305Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default observer(Logo)
